import { useState, useEffect } from 'react';
import Slider from 'react-slick';
import DynamicBreadcrumb from "../../include/DynamicBreadcrumb";
import { Link } from 'react-router-dom';

const BannerSection = ({ title, customBanner, staticConfig }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update screen type on resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false
  };

  // Determine images based on custom data from DB or static fallback
  let imagesToRender = [];
  let displayTitle = title;

  if (customBanner) {
    imagesToRender = isMobile ? customBanner.mobile_images : customBanner.desktop_images;
    displayTitle = customBanner.heading || title;
  } else if (staticConfig) {
    imagesToRender = staticConfig.bannerImages;
    displayTitle = staticConfig.heading;
  }

  return (
    <div className="alumni_banner">
      <section className="breadcrump_section">
        <Slider {...sliderSettings}>
          {imagesToRender && imagesToRender.length > 0 ? (
            imagesToRender.map((img, index) => (
              <div key={index} className="banner-slider">
                <img 
                  src={img.startsWith('http') ? img : `${process.env.REACT_APP_API_URL || ''}/public/${img}`} 
                  alt={`Banner ${index}`} 
                  className="img-fluid w-100" 
                  style={{ objectFit: 'cover', minHeight: isMobile ? '250px' : '400px' }}
                />
              </div>
            ))
          ) : (
            <div className="banner-slider">
              <img src="/assets/images/default-banner.webp" alt="Default" className="img-fluid w-100" />
            </div>
          )}
        </Slider>

        <div className="breadcrump-wrapper">
          <h1 className="breadcrump-heading">{displayTitle}</h1>
        </div>
        <DynamicBreadcrumb />
      </section>
    </div>
  );
};

export default BannerSection;